import React, { Component } from 'react';
import Switch from 'react-switch';
import PropTypes from 'prop-types';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import i18n from 'i18n-react';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class SwitchButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      completed: false,
      switchState: false,
      answerCorrect: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.checkAnswer = this.checkAnswer.bind(this);
  }

  handleChange() {
    const { switchState, completed } = this.state;
    const { answersCorrect } = this.props;

    if (!completed) {
      this.setState({ switchState: !switchState, answerCorrect: answersCorrect[(!switchState ? 0 : 1)] === 'true' });
    } else this.setState({ switchState });
  }

  checkAnswer() {
    const { answerCorrect, completed } = this.state;
    const { correctAnswerText, incorrectAnswerText, contentComplete } = this.props;

    if (!completed) {
      if (answerCorrect) {
        this.setState({ completed: true });
        toast.success(correctAnswerText, {
          position: 'bottom-center',
          transition: Zoom,
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        contentComplete();
      } else {
        toast.error(incorrectAnswerText, {
          position: 'bottom-center',
          transition: Zoom,
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
  }

  render() {
    const { switchState } = this.state;
    const { question } = this.props;

    return (
      <div className="container__question">
        <div className="container__question--content">
          <h4 className="container__title">{question}</h4>
          <div className="container__switch">
            <Switch
              onChange={this.handleChange}
              checked={switchState}
              className="react-switch"
              id="normal-switch"
              offColor="#c20000"
              height={40}
              width={80}
            />
            <h4>{i18n.translate(`trainingScreens.${switchState}`)}</h4>
          </div>
          <ToastContainer
            draggablePercent={70}
          />
          <button onClick={this.checkAnswer}>{i18n.translate('trainingScreens.confirm')}</button>
        </div>
      </div>
    );
  }
}

SwitchButton.propTypes = {
  answersCorrect: PropTypes.arrayOf(PropTypes.string).isRequired,
  contentComplete: PropTypes.func,
  correctAnswerText: PropTypes.string,
  error: PropTypes.func,
  incorrectAnswerText: PropTypes.string,
  layout: PropTypes.string,
  question: PropTypes.string,
};

SwitchButton.defaultProps = {
  contentComplete: false,
  correctAnswerText: '',
  error: () => {},
  incorrectAnswerText: '',
  layout: 'mMC',
  question: '',
};
